// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"63d19e69","453":"c994b55c","953":"ef391a5a"}[chunkId] + ".chunk.js";
};